import { recoverInternalNoteSchema } from "@redotech/redo-marketing-common/conversation/internal-note";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getRecoverInternalNotes = {
  name: "getRecoverInternalNotes" as const,
  input: z.object({ conversationId: zExt.objectId() }),
  output: z.object({ internalNotes: z.array(recoverInternalNoteSchema) }),
};
